export const LOGIN = "/";

export const EVENT_LIST = "/event";
export const EVENT_INFO = "/event-info";
export const EVENT_PREVIEW = "/event-preview";

export const DASHBOARD = "/dashboard";

export const GUEST_LIST = "/guest-list";
export const GUEST_BULK_PREVIEW = "/guest-bulk-preview";
export const GUEST_BULK_EDIT = "/guest-bulk-edit";
export const GUEST_ADD = "/guest-add";
export const GUEST_EDIT = "/guest-edit";

export const MESSAGE_BLAST = "/message-blast";
export const MESSAGE_BLAST_ADD = "/email-blast-add";
export const MESSAGE_BLAST_EDIT = "/email-blast-edit";
export const WHATSAPP_BLAST_ADD = "/whatsapp-blast-add";
export const WHATSAPP_BLAST_EDIT = "/whatsapp-blast-edit";
export const MESSAGE_BLAST_PREVIEW = "/message-blast-preview";

export const CHECKIN = "/checkin";
export const EVENT_CHECK_IN_PAGE = "/event-check-in-page";

export const SEATING_CHART = "/seating-chart";

export const REPORT_OVERVIEW = "/report-overview";
export const SEATS_MANAGEMENT = "/seats-management";
export const SEATS_MANAGEMENT_EDIT = "/seats-management-edit";

export const TAG_MANAGEMENT = "/tag-management";
export const TAG_MANAGEMENT_EDIT = "/tag-management-edit";

export const DIETARY_MANAGEMENT = "/dietary-management";
export const DIETARY_EDIT = "/dietary-edit";

export const GUEST_LIST_IMPORT_LOG = "/guest-import-log";
export const GUEST_LIST_IMPORT_LOG_DETAILS = "/guest-import-log-details";

export const CHANGE_LOG = "/change-log";

export const GUEST_INVITATION = "/guest/invitation";
export const GUEST_COUNTER = "/guest-counter";

export const USER_LIST = "/admin/user-list";
export const USER_CREATE = "/admin/user-create";
export const USER_EDIT = "/admin/user-edit";

export const LOW_END_EVENT_LIST = "/low-end/event-list";
export const LOW_END_EVENT_INFO = "/low-end/event-info";
export const LOW_END_GUEST_LIST = "/low-end/guest-list";
export const LOW_END_CHECKIN = "/low-end/checkin";
